"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var BehaviourBuilder_1 = require("./BehaviourBuilder");
var EditorTypes_1 = require("../EditorTypes");
var WidgetActions = __importStar(require("./WidgetActions"));
var CopyActions_1 = require("./CopyActions");
var PasteActions_1 = require("./PasteActions");
var FeatureFlag_1 = require("@CommonFrontendBackend/FeatureFlag");
var zod_1 = __importDefault(require("zod"));
var utils_1 = require("@qwilr/kaleidoscope/utils");
var SyntheticSelectionActions = __importStar(require("./SyntheticSelectionActions"));
var slate_react_1 = require("slate-react");
exports.default = (function (di, router) {
    var editorTelemetry = di.get("editorTelemetry");
    var usingFeature = di.get("usingFeature");
    return [
        di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("removeGenericWidget")
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: "any", action: "delete" })
            .doAction(function (event, editor) {
            SyntheticSelectionActions.removeWidgetsAtSelection([{ editor: editor, path: event.data.path }], "backward");
            slate_react_1.ReactEditor.focus(editor);
            editorTelemetry.inlineContentDeleted(event.data.type);
            return true;
        }),
        di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("pasteOverGenericWidget")
            .isEvent(EditorTypes_1.EventType.Insert)
            .inFullySelectedRegistryWidget()
            .doAction(function (event, editor) {
            (0, PasteActions_1.insertAndOverride)(editor, event.fragment, usingFeature(FeatureFlag_1.FeatureFlag.PublicApi));
            return true;
        }),
        di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("cutGenericWidget")
            .isEvent(EditorTypes_1.EventType.Cut)
            .inFullySelectedRegistryWidget()
            .doAction(function (event, editor) {
            event.preventDefault();
            (0, CopyActions_1.cutWidget)(event, editor);
            return true;
        }),
        di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("enterOnGenericWidget")
            .isEvent(EditorTypes_1.EventType.Key)
            .withKey(BehaviourBuilder_1.KeyType.Enter)
            .inFullySelectedRegistryWidget()
            .doAction(function (event, editor) {
            event.preventDefault();
            WidgetActions.newParagraphBelowWidget(editor);
            return true;
        }),
        di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("updateGenericWidget")
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: "any", action: "update" })
            .doAction(function (event, editor) {
            WidgetActions.updateWidget(editor, event.data.path, event.data.data);
            return true;
        }),
        di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("resizeGenericWidget")
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: "any", action: "resize" })
            .doAction(function (event, editor) {
            var parsedEvent = resizeGenericWidgetEventSchema.parse(event);
            var _a = parsedEvent.data, nextWidth = _a.nextWidth, nextHeight = _a.nextHeight;
            WidgetActions.updateWidget(editor, event.data.path, __assign({ width: nextWidth }, (0, utils_1.includeIf)(!!nextHeight, { height: nextHeight })));
            return true;
        }),
        di
            .make(BehaviourBuilder_1.BehaviourBuilder)
            .isCalled("duplicateGenericWidget")
            .isEvent(EditorTypes_1.EventType.Widget)
            .withData({ widget: "any", action: "duplicate" })
            .doAction(function (event, editor) {
            WidgetActions.duplicateWidget(editor, event.data.path);
            return true;
        }),
    ];
});
var resizeGenericWidgetEventSchema = zod_1.default.object({
    data: zod_1.default.object({
        path: zod_1.default.array(zod_1.default.number()),
        nextWidth: zod_1.default.union([zod_1.default.enum(["full", "wide", "content"]), zod_1.default.number()]),
        nextHeight: zod_1.default.number().optional(),
    }),
});
